export const FORGOT_PASSWORD_HEADER = "forgot-password-header";
export const FORGOT_PASSWORD_CONTINUE_BUTTON =
  "forgot-password-continue-button";
export const FORGOT_PASSWORD_DESCRIPTION = "forgot-password-description";
export const FORGOT_PASSWORD_NEED_HELP_CONTENT =
  "forgot-password-need-help-content";
export const FORGOT_PASSWORD_NEED_HELP_TITLE =
  "forgot-password-need-help-title";
export const FORGOT_PASSWORD_FORM = "forgot-password-form";
export const FORGOT_PASSWORD_BACK_BUTTON = "forgot-password-back-button";
export const MATCH_NOT_FOUND = "MATCH_NOT_FOUND";
export const USERNAME_VERIFIED_SUCCESSFULLY = "USERNAME_VERIFIED_SUCCESSFULLY";
